import {
  createOemTrayApiClient,
  type OemTrayApiClient,
} from '@peritasai/data-access';
import type { TrayPredictionRequestDto } from '@peritasai/types';
import { TrayPredictionEntity } from './tray-prediction.entity';

/**
 * Business-entity access to the OEM tray prediction microservice. Delegates all
 * HTTP concerns to {@link OemTrayApiClient} and maps the validated DTO to a
 * {@link TrayPredictionEntity}.
 */
export class OemTrayRepository {
  constructor(private readonly apiClient: OemTrayApiClient) {}

  /** Whether the real prediction API is configured. */
  isEnabled(): boolean {
    return this.apiClient.isEnabled();
  }

  /** Run inference on a captured frame; throws when the API is disabled. */
  async predict(
    request: TrayPredictionRequestDto,
    signal?: AbortSignal
  ): Promise<TrayPredictionEntity> {
    const dto = await this.apiClient.predict(request, signal);
    return new TrayPredictionEntity(dto);
  }
}

export const oemTrayRepository = new OemTrayRepository(createOemTrayApiClient());
